module.exports = __webpack_public_path__ + "static/media/oppo-indonesia-2.58c0ff4d.jpg";